/**
 * Dependency Viewer Feature Module
 *
 * Registers the dependency-viewer workspace type and exports public APIs.
 */

import { registerWorkspaceComponent } from '../core/registry/workspaceRegistry';
import { lazyWorkspaceTab } from '../core/registry/lazyWorkspaceTab';

// Register the dependency-viewer workspace component
registerWorkspaceComponent(
  'dependency-viewer',
  lazyWorkspaceTab(() => import('./components/DependencyViewerTab').then((m) => ({ default: m.DependencyViewerTab }))),
);

// Re-export components
